import {
  MIN_INTERVAL,
  FIVE_MIN_INTERVAL,
  TEN_MIN_INTERVAL,
  THIRTY_MIN_INTERVAL,
  HOUR_INTERVAL,
  TWO_HOUR_INTERVAL,
  DAY_INTERVAL,
} from "@/app/activity/components/timeline/activityTimeline/constants"
import { Activity } from "@/types/activity"
import { ActivityDurationData } from "@/types/data"
import { Session } from "@/types/session"
import { Duration } from "date-fns"
import { RefObject } from "react"

export enum RangeKey {
  _24h = "24h",
  ACTIVITY = "activity",
  CROP = "crop",
}

export type Tick = {
  show?: boolean
  key: RangeKey
  label: number | string
  date?: Date
  unit: "minutes" | "hours" | "week" | "months"
  timeInterval?:
    | typeof MIN_INTERVAL
    | typeof FIVE_MIN_INTERVAL
    | typeof TEN_MIN_INTERVAL
    | typeof THIRTY_MIN_INTERVAL
    | typeof HOUR_INTERVAL
    | typeof TWO_HOUR_INTERVAL
    | typeof DAY_INTERVAL
  add?: Duration
  x?: number
  text?: string
  boldText?: string
  isMidnight?: boolean
}

export type TimelineTickProps = {
  width: number
  dateStart?: Date
  dateFinish?: Date
  rangeKey: RangeKey
  transform?: string
  magnification?: number
}

export enum Magnification {
  INIT = 1,
  HALF = 0.5,
  QUAD = 4,
  DOUBLE = 2,
}

export type ActivityTimelineProps = {
  dateStart: Date
  dateFinish: Date
  isLoading: boolean
  rangeKey?: RangeKey
  activityDurationData?: ActivityDurationData[]
  pastActivityDurationData?: ActivityDurationData[]
  futureActivityDurationData?: ActivityDurationData[]
  currentItemList?: Array<Activity | Session>
  pastItemList?: Array<Activity | Session>
  futureItemList?: Array<Activity | Session>
  isAddingBox: boolean
  height?: number

  onBoxClick?: (item: unknown) => void
}

export type ExistActivityData = {
  dateStart: string
  dateFinish: string
  startX: number
}

export type ActivityDataProps = {
  dateStart: string
  dateFinish: string
  startX: number
  width: number
  isLive?: boolean
}

export type ChartSymbolProps = {
  color: string
  scale: number
  width: number
  height: number
}

export type Range = {
  dateStart?: Date
  dateFinish?: Date
}

export enum ActivityStatus {
  none = "none",
  modify = "modify",
  add = "add",
}

export enum ActivityAction {
  openDialog = "open-dialog",
  closeDialog = "close-dialog",
  matchDataToPlayer = "match-data-to-player",

  createSetup = "createSetup",
  createDone = "createDone",
  cancel = "cancel",
  createActivity = "create",
  deleteActivity = "delete",
  updateActivity = "update",
  updateTempActivity = "update-temp",

  addStatus = "add-status",
  modifyStatus = "modify-status",
  closeStatus = "close-status",

  selectActivity = "select-activity",
}

export enum SessionStatus {
  none = "none",
  modify = "modify",
  add = "add",
}

export enum SessionAction {
  openDialog = "open-dialog",
  closeDialog = "close-dialog",

  createSession = "create",
  deleteSession = "delete",
  updateSession = "update",
  updateTempSession = "update-time",

  addStatus = "add-status",
  modifyStatus = "modify-status",
  closeStatus = "close-status",
}

export type TimelineItemBoxProps = {
  id: number
  startX: number
  startY: number
  width: number
  height: number
  fillColor: string
  strokeColor: string
  name?: string
  hoverable: boolean
  editable: boolean
  rangeKey: RangeKey
  className?: string
  remainRightArea?: number
  magnification?: number
  isSession?: boolean
  onDragStart?: (event?: React.MouseEvent<SVGSVGElement, MouseEvent>) => void
  onDragEnd?: (event: TimelineDragEvent) => void
  onDrag?: (event: TimelineDragEvent) => void
  onClick?: (item: unknown) => void
} & Partial<Session> &
  Partial<Activity>

export type TimelineDragEvent = {
  id: number
  direction: string
  moveX: number
  startX: number
  endX: number
  subject?: unknown
  isActivity?: boolean
  event?: MouseEvent
}

export type TimelineAddBoxProps = {
  isSession: boolean
  svgRef: RefObject<SVGSVGElement | null>
}
